import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TrailerTypeService} from 'app/blocks/service/api/trailer-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ITrailerType} from 'app/blocks/model/trailer-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {TrailerType} from 'app/blocks/model/trailer-type.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class TrailerTypeResource extends AbstractEntityResource<ITrailerType> {
    constructor(trailerTypeService: TrailerTypeService, router: Router) {
        super(
            Resource.TRAILER_TYPES,
            trailerTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TRAILER_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TRAILER_TYPES),
            (entity?) => new TrailerType(entity),
            (entity) => entity.id,
            'style'
        );
    }
}
